import create from 'zustand'
import { persist } from "zustand/middleware"

const persistConfig = {
  name: "social-login-path"
};

const SocialLoginStore = create(persist((set, get) => {

  const setTargetPathAction = async ({to, from}) => {
    if (to && from) {
      const targetPath = {
        pathname: to, 
        state: { from: from }
      }
      set({ targetPath })
    } else {
      set({ targetPath: null })
    }
  }

  const clearAllAction = () => set({
    ...initState
  })

  const initState = {
    targetPath: null,
  }
  
  return {
    ...initState,
    setTargetPath: setTargetPathAction,
    clearAll: clearAllAction,
  }
}, persistConfig));

export default SocialLoginStore;